import {releaseBasketV2} from "../../../services/api/mergerApi"

export default async function (basketId) {
    try {
        const {data: response} = await releaseBasketV2(basketId)

        const {success, data, error} = response

        if (!success) {
            throw new Error(error)
        }

        return data
    } catch (e) {
        throw new Error(e)
    }
}
